import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React__default, { useState, Fragment, useContext } from 'react';
import styled, { css, ThemeContext } from 'styled-components';
import ReactSelect from '../../node_modules/react-select/dist/react-select.esm.js';
import { FixedSizeList } from '../../node_modules/react-window/dist/index.esm.js';
import CountryIconOption from '../../utils/country-icon-options.js';
import classNames from '../../node_modules/classnames/index.js';
import img$2 from '../../images/select-arrow.svg.js';
import img from '../../images/select-arrow-open-dark.svg.js';
import img$1 from '../../images/select-arrow-open-light.svg.js';
import Text from '../text/text.component.js';
import { getPrefixFromLng } from '../../utils/utils.js';
import { backgroundColor, color, colorPlaceholderSelect, backgroundHoverSelect, errorStyleFocus, errorStyle } from '../../theme/textfield-theme.js';
import { c as components } from '../../node_modules/react-select/dist/index-4bd03571.esm.js';
var _excluded = ["children"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function AddIcons(options) {
  return options.map(function (option) {
    return {
      value: option.value,
      label: /*#__PURE__*/React__default.createElement(Fragment, null, /*#__PURE__*/React__default.createElement("span", null, option.label))
    };
  });
}
/*

          {
            hasComboboxIcon ? <img src={option.value == initialValues ? CircleGreen : CircleGrey} style={{float: "right"}}/> : isNull
          }

*/

var CustomSelect = styled(ReactSelect).withConfig({
  displayName: "select-basiccomponent__CustomSelect",
  componentId: "sc-1wtzlds-0"
})(["", " padding-left:16px;padding-right:16px;border-radius:16px;position:relative;width:100%;height:56px;display:flex;user-select:none;justify-content:center;font-family:Graphik-Regular,Arial;font-weight:400;font-size:16px;line-height:20px;& input{", "}& > div{", " border:none !important;box-shadow:none;width:100%;}& > div > div > span{display:none;}.react-select__value-container{margin-top:auto;padding-left:0px !important;}.react-select__placeholder{", " font-family:Graphik-Regular,Arial !important;font-weight:400 !important;font-size:16px !important;line-height:20px;}.react-select__single-value{", "}.react-select__menu{&::-webkit-scrollbar{display:none;}& span{font-family:Graphik-Regular;font-weight:400;font-size:16px;line-height:22px;}border-radius:16px;margin-top:12px;padding:12px 0px 12px 0px;box-shadow:0px 4px 12px rgba(0,0,0,0.05);}.react-select__menu-list,.select-list{&::-webkit-scrollbar{display:none;}}.react-select__option{", " font-family:Graphik-Regular;font-weight:400;font-size:16px;line-height:22px;cursor:pointer;background-color:transparent !important;&:hover{", "}}.flag-icon{background-size:cover !important;background-position:center center !important;background-repeat:no-repeat;}"], backgroundColor, color, backgroundColor, colorPlaceholderSelect, color, color, backgroundHoverSelect);
var Container = styled.div.withConfig({
  displayName: "select-basiccomponent__Container",
  componentId: "sc-1wtzlds-1"
})(["border-radius:16px;position:relative;width:100%;height:56px;& > .textfield-label{display:block;position:absolute;transition:all 0.3s;left:16px;user-select:none;transform-origin:left top;", "}& > .textfield-input{box-shadow:none;border-style:none;transition:all 0.3s;}.textfield-input::placeholder{color:transparent !important;}& .textfield-input:focus,& .textfield-input:not(:placeholder-shown){&::placeholder{", "}}"], function (props) {
  return props.menuIsOpen || props.isFocused || props.selectValue != "" ? css(["top:8px;transform:scale(0.75);"]) : css(["top:calc(50% - 11px);"]);
}, function (props) {
  return props.hasPlaceholder ? placeholderColor : "";
});
var LineInputBorder = styled.div.withConfig({
  displayName: "select-basiccomponent__LineInputBorder",
  componentId: "sc-1wtzlds-2"
})(["width:100%;height:1px;background-color:transparent;& div{width:", ";opacity:", ";height:1px;transition:all 0.2s cubic-bezier(0.4,0,0.2,1);margin-left:16px;margin-right:16px;", "}"], function (props) {
  return props.hasFocus || props.hasErrors == "true" ? "calc(100% - 32px)" : "0px";
}, function (props) {
  return props.hasFocus || props.hasErrors == "true" ? "1" : "0";
}, function (props) {
  return props.hasFocus || props.hasErrors == "true" ? errorStyleFocus : errorStyle;
});
var SingleValue = function SingleValue(_ref) {
  _ref.children;
  var props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(components.SingleValue, props, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, props.data.label, props.getValue() && props.getValue().length > 0 && props.getValue()[0] ? " (" + getPrefixFromLng(props.getValue()[0].value) + ")" : null)));
};
var DropdownIndicator = function DropdownIndicator(_ref2) {
  var props = _extends({}, _ref2);
  return components.DropdownIndicator && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(components.DropdownIndicator, props, /*#__PURE__*/React__default.createElement("img", {
    className: "select-arrow",
    style: {
      height: "27px"
    },
    src: props.selectProps.menuIsOpen ? useContext(ThemeContext).layout == "dark" ? img : img$1 : img$2,
    alt: "icon"
  })));
};
var MenuList = function MenuList(_ref3) {
  var props = _extends({}, _ref3);
  var height = 56;
  var options = props.options,
    children = props.children;
  props.maxHeight;
  var getValue = props.getValue;
  var _getValue = getValue(),
    _getValue2 = _slicedToArray(_getValue, 1),
    value = _getValue2[0];
  var initialOffset = options.indexOf(value) * height;
  var realMaxHeight = children.length > 5 ? height * 5 : height * children.length; //setMenuHeight(height * children.length);

  return components.MenuList && /*#__PURE__*/React__default.createElement(FixedSizeList, {
    height: realMaxHeight,
    itemCount: children.length,
    itemSize: height,
    initialScrollOffset: initialOffset,
    className: "select-list",
    style: {
      overflow: children.length > 6 ? "scroll" : "hidden"
    }
  }, function (_ref4) {
    var index = _ref4.index,
      style = _ref4.style;
    return /*#__PURE__*/React__default.createElement("div", {
      style: style
    }, children[index]);
  });
};
/**
 * @deprecated
 */

var SelectBasic = function SelectBasic(_ref5) {
  var isSearchable = _ref5.isSearchable;
  _ref5.hasIcon;
  var options = _ref5.options;
  _ref5.placeholder;
  var fontFamily = _ref5.fontFamily,
    label = _ref5.label,
    hasComboboxIcon = _ref5.hasComboboxIcon,
    initialValues = _ref5.initialValues,
    top = _ref5.top,
    name = _ref5.name,
    isCountry = _ref5.isCountry,
    _onChange = _ref5.onChange;
  _ref5.onBlur;
  var value = _ref5.value,
    style = _ref5.style,
    baseColor = _ref5.baseColor;
  _ref5.color;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuIsOpen = _useState2[0],
    setMenuIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFocused = _useState4[0],
    setIsFocused = _useState4[1];
  var _useState5 = useState(value || ""),
    _useState6 = _slicedToArray(_useState5, 2),
    selectValue = _useState6[0],
    setSelectValue = _useState6[1];
  var select = /*#__PURE__*/React__default.createRef();
  return /*#__PURE__*/React__default.createElement(Container, {
    selectValue: selectValue,
    menuIsOpen: menuIsOpen,
    isFocused: isFocused,
    style: style
  }, /*#__PURE__*/React__default.createElement(CustomSelect, {
    color: "normal",
    baseColor: baseColor,
    ref: select,
    isSearchable: isSearchable ? true : false,
    defaultValue: initialValues && options ? AddIcons(options).find(function (option) {
      return option.value == initialValues;
    }) : "",
    options: options,
    components: isCountry ? {
      Option: CountryIconOption,
      DropdownIndicator: DropdownIndicator,
      SingleValue: SingleValue,
      MenuList: MenuList
    } : {
      DropdownIndicator: DropdownIndicator,
      MenuList: MenuList
    },
    hideSelectedOptions: true
    /*placeholder={placeholder}*/,

    placeholder: "",
    name: name,
    value: value,
    onMenuOpen: function onMenuOpen() {
      setMenuIsOpen(true);
    },
    onMenuClose: function onMenuClose() {
      setMenuIsOpen(false);
    },
    onFocus: function onFocus() {
      setIsFocused(true);
    },
    menuIsOpen: menuIsOpen,
    onChange: function onChange(option) {
      setSelectValue(option.value);
      _onChange(option);
    },
    onBlur: function onBlur(e) {
      if (e.relatedTarget && e.relatedTarget.classList.contains("textfield-label")) {
        select.current.focus();
      } else {
        setIsFocused(false);
      }
    },
    className: classNames({
      "react-select-container": true,
      "react-select-combobox-icons": hasComboboxIcon,
      "textfield-select": true
    }),
    classNamePrefix: "react-select",
    menuPlacement: top ? "top" : "bottom",
    styles: {
      dropdownIndicator: function dropdownIndicator(provided, state) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          transition: "0.2s",
          transform: state.selectProps.menuIsOpen
        });
      }
    }
  }), /*#__PURE__*/React__default.createElement(Text, {
    fontFamily: fontFamily.toLowerCase(),
    type: "paragraph",
    fontSize: "medium",
    className: "textfield-label",
    tag: "label",
    color: "grey-1",
    tabIndex: "0",
    onClick: function onClick() {
      select.current.focus();
    }
  }, label ? label : ""), /*#__PURE__*/React__default.createElement(LineInputBorder, {
    hasFocus: menuIsOpen || isFocused,
    hasErrors: "false"
  }, /*#__PURE__*/React__default.createElement("div", null)));
};
SelectBasic.defaultProps = {
  fontFamily: "graphik" //persistentPlaceholder: true
};

export { SelectBasic, SelectBasic as default };